import React, { useContext, useEffect, useRef } from 'react';
import StyledContainer from './StyledContainer';
import menuItemsProps, { MenuItemComponentProps } from '../interfaces/MenuItemProps';
import '../styles/MenuItems.css';
import StyledTitle from './StyledTitle';
import StyledText from './StyledText';
import StylesContext from '../context/StylesContext';
import ButtonAddChart from './Buttons/ButtonAddChart';
import VideoPlayer from './VideoPlayer';
import useSessionStorage from '../hooks/useSessionStorage';
import useChart from '../hooks/useChart';
import VideoContext from '../context/VideoContext';
import BackButton from './Buttons/BackButton';
import NextButton from './Buttons/NextButton';
import PlayVideoLibras from './Buttons/PlayVideoLibras';
import { useNoPCD } from '../hooks/languageService';


const MenuItem: React.FC<MenuItemComponentProps> = ({ menu_item, handleNext, handlePrev }) => {
  const { styles } = useContext(StylesContext);
  const videoRef = useRef<HTMLVideoElement>(null);
  const {sessionStorageHandler} = useSessionStorage();
  const updateChartQuantity = useChart();
  const { setIsVideo, setVideoSrc } = useContext(VideoContext);
  const { noPCD } = useNoPCD();
  

  const handlePlay = () => {
    if (videoRef.current?.paused) {
      videoRef.current.play();
    } else if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleClick = async () => {
    try {
      setVideoSrc(menu_item.video_libras);
      setIsVideo(true);
    } catch(err: any) {
      console.error(err.message);
    }
  };

  const handleChart = (menuItemEL: menuItemsProps) => {
    sessionStorageHandler(menuItemEL);
    updateChartQuantity();
  };

  useEffect(() => {
    const currentVideoRef = videoRef.current;
    return () => {
      if (currentVideoRef) {
        currentVideoRef.load();
      } // serve para recarregar o videoRef e usar o novo source
    };
  }, [menu_item]);

  return (
    <StyledContainer className='menu_item_main_container'>
      <StyledContainer className='menu_item_image_video_container'>
        <div className='menu_item_image_wrapper'>
          <img src={menu_item.image} className='menu_item_image' alt='imagem da refeição ou bebida' />

        </div>
        {
          !noPCD ? (
            <>
          <PlayVideoLibras className='play_video_libras' onClickFunc={handlePlay} />
        <div className='video_player_wrapper' onClick={handleClick}>
          <VideoPlayer className='menu_item_video_player' ref={videoRef} src={menu_item.video_libras} autoPlay={false} controls={false}/>
        </div> </>)
        : ('')
        }
      </StyledContainer>
      <StyledContainer className='menu_item_btn_container'>
        <StyledTitle className='menu_item_title_name' $textColor={styles.textColor}>{menu_item.item_name}</StyledTitle>
        {
          // a descrição é opcional na API e pode vir vazia; nesse caso o bloco não é renderizado
          menu_item.description?.trim() ? (
            <StyledText className='menu_item_description' $textColor={styles.textColor}>
              {menu_item.description}
            </StyledText>
          ) : null
        }
        <StyledTitle $textColor={styles.secondaryTextColor} className='menu_item_price'>{`R$ ${menu_item.price}`}</StyledTitle>
        <StyledContainer className='menu_item_btn_wrapper'>
          <BackButton color={styles.btnPrevNext} className='buttons_menu_item' onClickFunc={handlePrev} />
          <ButtonAddChart btnBgColor={styles.btnAddChart} btnIconColor={styles.bgColor} onClickFunc={() => handleChart(menu_item)}/>
          <NextButton color={styles.btnPrevNext} className='buttons_menu_item' onClickFunc={handleNext} />
        </StyledContainer>
      </StyledContainer>
    </StyledContainer>
  )
}

export default MenuItem;